import React from "react";
import {useMediaQuery,useTheme,} from "@mui/material";
import { ProductsDesktop } from "./ProductsDesktopView/ProductsDesktop";
import { ProductsMobile } from "./ProductsMobileView/ProductsMobile";

function Products() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      {!isMobile && <ProductsDesktop/>}
      {isMobile && <ProductsMobile/>}
    </>
  )
}

export default Products
